<template>
  <!-- 時間外管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>予定外時間外報告</span>
        <span class="card-header-actions">
          <!-- 時間外管理登録画面へ遷移するボタン -->
          <router-link :to="{ name: overTimesRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" class="title">ステータス</th>
              <th scope="col" class="title">申請日</th>
              <th scope="col" class="title">予定時間外勤務時間</th>
              <th scope="col" class="title">発生理由</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td>提出済</td>
              <td>
                <router-link
                  :to="{ name: overTimesInfo, params: { id: item.id } }"
                  >{{ formatDate(item.updated_at) }}</router-link
                >
              </td>
              <td>{{ item.overtime }}H</td>
              <td>{{ item.reason }}</td>
              <td>
                <save-button
                  :label="'削除'"
                  :loading="loading"
                  @click="deleteOvertime(item.id)"
                  class="btn btn-danger"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import VPagination from "vuejs-paginate";
import SaveButton from "../../common/SaveButton";
export default {
  name: "List",
  components: {
    VPagination,
    SaveButton,
  },
  data() {
    return {
      showModal: false,
      postItem: "",
      items: [],
      employee_id: [],
      deleted_flg: [],
      authority: [],
      errors: [],
      overTimesRegister: "",
      overtimesInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.overTimesRegister = ConstList.ROUTE_OVERTIMES_REGISTER;
    this.overTimesInfo = ConstList.ROUTE_OVERTIMES_INFO;
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },

  methods: {
    callList: function () {
      {
        const params = new URLSearchParams();
        params.append("currentPage", this.currentPage);
        params.append("pageSize", this.pageSize);
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/overtime", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            this.items = response.data;
            if (this.items.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
            this.items.forEach((element) => {
              element.updated_at = element.updated_at.slice(0, 10);
            });
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },
    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/overtimeCount")
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        });
    },

    // 時間外申請を削除
    deleteOvertime: function (id) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      if (confirm("削除してもよろしいですか？")) {
        //フラグがfalseならば、フラグをtrueにしたうえでsubmit
        this.loading = true;
        this.submit_flg = true;
        const params = new URLSearchParams();
        params.append("id", id);
        axios
          .post(process.env.VUE_APP_API_ORIGIN + "/overtimeDelete", params)
          .then(() => {
            this.submit_flg = false;
            alert(ConstList.DELETE_MESSAGE);
            this.showModal = false;
            window.location.reload();
          })
          .catch((error) => {
            this.submit_flg = false;
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
};
</script>

<style scoped>
th,
td {
  white-space: nowrap;
}
td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
